/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber10Small = createReactComponent("number-10-small", "IconNumber10Small", [
  ["path", { d: "M7 10l2 -2v8", key: "svg-0" }],
  ["path", { d: "M13 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", key: "svg-1" }]
]);

export { IconNumber10Small as default };
//# sourceMappingURL=IconNumber10Small.js.map
